import { store } from '@betacrew/jars-flux'
import DateUtils from '../../../../libs/utility/DateUtils';
export const componentKey = "ACTIVITY_LOG";

const { actions } = store.reducerManager.add({
	key: componentKey,
	addedReducers: {
		setLoadingState: (state, action) => {
			state.loadingState = action.payload;
		},
		setUserName: (state, action) => {
			state.userName = action.payload;
		},
		setEventName: (state, action) => {
			state.eventName = action.payload;
		},
		setRowsPerPage: (state, action) => {
			state.rowsPerPage = action.payload;
		},
		setSkip: (state, action) => {
			state.skip = action.payload;
		},
		setRole: (state, action) => {
			state.role = action.payload;
		},
		setStartDate: (state, action) => {
			state.startDate = action.payload;
		},
		setEndDate: (state, action) => {
			state.endDate = action.payload;
		},
		setActivityLogs: (state, action) => {
			state.activityLogs = action.payload;
		},
		setSelectedLog: (state, action) => {
			state.selectedLog = action.payload;
		},
		setTotalLogs: (state, action) => {
			state.totalLogs = action.payload;
		},
		setExportFile: (state, action) => {
			state.exportFile = action.payload;
		},
	},
	initialReducerState: {
		userName: "",
		eventName: "",
		rowsPerPage: 10,
		skip: 0,
		role: "User",
		startDate: DateUtils.dateFormatter(DateUtils.dateSubtractor(7, 'd'), 'MM/DD/YYYY'),
		endDate: DateUtils.dateFormatter(new Date(), 'MM/DD/YYYY'),
		activityLogs: [],
		selectedLog: null,
		totalLogs: 0,
		loadingState: false,
		exportFile: {},
	}
});
export const { setUserName, setLoadingState, setEventName, setRowsPerPage, setSkip, setRole, setStartDate, setEndDate, setActivityLogs, setSelectedLog, setTotalLogs, setExportFile } = actions;